import React from "react";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MasterGroupMerchandiseCategoryList } from "./list/list";
import { setMerchandiseTypesOptions } from "../../../../../redux/reducers/catalog/catalog";
import { resetMasterGroupMerchandiseCategoryList } from "../../../../../redux/reducers/resources/master/groupMerchandiseCategory/list";

export class MasterMerchandiseGroupCategoryContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterGroupMerchandiseCategoryList());
        store.dispatch(setMerchandiseTypesOptions([]));
    }

    render(): React.ReactNode {
        return (
            <MasterGroupMerchandiseCategoryList
                widthPopUp={widths.master.default}
                heigthPopUp={heights.master.default}
            />
        );
    }
}
